/** Keep in sync with constants.scss */
export const RIBBON_BLEEDTHROUGH_BOTTOM_PADDING = 4;
export const APP_RIBBON_SECTION = 'Ribbon';
